import { getSystemDb, wakeLocalWrite } from '@firesquirrel/local-db';
import { writeAuditLog } from './systemAuditLogService';

export async function listOrganizations(): Promise<any[]> {
  const db = await getSystemDb();
  const docs = await db.organizations.toArray();
  return docs.filter((d: any) => !d._deleted);
}

export async function getOrganization(id: string): Promise<any | null> {
  const db = await getSystemDb();
  const doc = await db.organizations.get(id);
  return doc ?? null;
}

export async function upsertOrganization(data: any): Promise<void> {
  const db = await getSystemDb();
  const isNew = !(await db.organizations.get(data._id));
  await db.organizations.put({ ...data, updatedAt: new Date().toISOString() });
  wakeLocalWrite('organizations');
  writeAuditLog({
    collection: 'organizations',
    documentId: data._id,
    action: isNew ? 'create' : 'update',
    summary: isNew ? `Created organization "${data.name}"` : `Updated organization "${data.name}"`,
  }).catch((err) => {
    console.warn('[organizationService] Failed to write audit log for organization upsert:', err);
  });
}

export async function deleteOrganizationLocal(id: string): Promise<void> {
  const db = await getSystemDb();
  const existing = await db.organizations.get(id);
  if (!existing) return;
  const now = new Date().toISOString();
  await db.organizations.put({ ...(existing as any), _deleted: true, deletedAt: now, updatedAt: now });
  wakeLocalWrite('organizations');
}
